import React from 'react';
import ReactDOM from 'react-dom';
import { SnackbarProvider } from 'notistack';
import App from './App';
import TagManager from 'react-gtm-module';

const tag = process.env.REACT_APP_GTM_ID;

if (tag) {
  const tagManagerArgs = {
    gtmId: tag,
  };

  TagManager.initialize(tagManagerArgs);
}

ReactDOM.render(
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
  >
    <App />
  </SnackbarProvider>,
  document.getElementById('root')
);
